import React from 'react';

import type { SimpleIconInterface } from './icon-utils';
import { SimpleIcon } from './icon-utils';

export function ChatHelpIcon({
  height,
  stroke = 'currentColor',
  width,
  ...rest
}: SimpleIconInterface): JSX.Element {
  return (
    <SimpleIcon
      fill="none"
      height={height ?? 24}
      viewBoxDimensions="0 0 24 24"
      width={width ?? 24}
      {...rest}
    >
      <path
        d="M4.5 18h-0.75a3 3 0 0 1 -3 -3v-3a3 3 0 0 1 3 -3h0.75a0.75 0.75 0 0 1 0.75 0.75v7.5a0.75 0.75 0 0 1 -0.75 0.75Z"
        fill="none"
        stroke={stroke}
        strokeLinecap="round"
        strokeLinejoin="round"
        strokeWidth="1.5"
      ></path>
      <path
        d="M20.25 18h-0.75a0.75 0.75 0 0 1 -0.75 -0.75v-7.5A0.75 0.75 0 0 1 19.5 9h0.75a3 3 0 0 1 3 3v3a3 3 0 0 1 -3 3Z"
        fill="none"
        stroke={stroke}
        strokeLinecap="round"
        strokeLinejoin="round"
        strokeWidth="1.5"
      ></path>
      <path
        d="M3.75 9A8.25 8.25 0 0 1 12 0.75h0A8.25 8.25 0 0 1 20.25 9"
        fill="none"
        stroke={stroke}
        strokeLinecap="round"
        strokeLinejoin="round"
        strokeWidth="1.5"
      ></path>
      <path
        d="M15 21.75h2.25a3 3 0 0 0 3 -3h0V18"
        fill="none"
        stroke={stroke}
        strokeLinecap="round"
        strokeLinejoin="round"
        strokeWidth="1.5"
      ></path>
      <path
        d="M13.5 23.25H12a1.5 1.5 0 0 1 -1.5 -1.5h0a1.5 1.5 0 0 1 1.5 -1.5h1.5a1.5 1.5 0 0 1 1.5 1.5h0a1.5 1.5 0 0 1 -1.5 1.5Z"
        fill="none"
        stroke={stroke}
        strokeLinecap="round"
        strokeLinejoin="round"
        strokeWidth="1.5"
      ></path>
    </SimpleIcon>
  );
}
